import { MODULE } from "./template-lists.actionTypes";

export const isFetchingTemplatesStatus = (state) =>
  state.getIn([MODULE, "isFetchingTemplatesStatus"]);

export const getTemplates = (state) => state.getIn([MODULE, "templates"]);

export const getLoading = (state) => state.getIn([MODULE, "loading"]);

export const isSelectTemplateModalVisible = (state) =>
  state.getIn([MODULE, "isSelectTemplateModalVisible"]);
